import React, { useState, useEffect/*, useRef */} from 'react';
import {Button } from "reactstrap";
import Navbar from '../Navbar/Navbar';
import Footer from "../Footer/Footer";

import { useParams } from "react-router-dom";

import './Forms.css';
// import parse from 'html-react-parser';

import Swal from 'sweetalert2'

import * as Hosts from '../../../Hosts';
import {
    set_language,
    reqGET,
	content_language,
    functionSendMail,

} from '../../../Utils';


import { language } from '../WEBContent/Language';


const RequestRecoveryForm = () => {

    const { hash } = useParams();

    const [lang, set_lang] = useState('pt');
    const [/*lang_id*/, set_lang_id] = useState('1');
    
    const [email_request, set_email_request] = useState(''); 
    const [link_final, /*set_link_final*/] = useState(Hosts.EMAIL_WEB_SITE_URL);

    useEffect(() => { 

        if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if(el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }
    
    }, []); 

    const handleSubmit = async e => {
        e.preventDefault();

        if(email_request === '') {
            Swal.fire(language[lang].confirmation_email_error_message, '', 'error')
        }
        else {

            await reqGET(Hosts.SIMCore_API + '/entities/password/recovery/' + Hosts.companycode + '/' + email_request)
                .then(async res => {

                    if(res.status === 200) {
                        let link_aux = link_final + '/regist/client/recovery/' + res.data

                        let mail_content = '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR + ';border:1px solid transparent;border-collapse:collapse;">' +
                                                '<tr style="border-collapse: collapse;">' +
                                                    '<td align="left" class style="padding:40px; border-collapse:collapse;">' +
                                                        '<div>'+
                                                            '<h4 style="margin-top:0; text-transform: uppercase;">'+ language[lang].contact_recovery +':</h4>'+
                                                            '<span><label>' + language[lang].password_recover + '</label></span>'+
                                                            '<br/>'+
                                                            '<br/>'+
                                                            '<span><label>' + language[lang].password_recover_2 + ' <a href="'+ link_aux +'" alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '">' + language[lang].recover_password + '</a></label></span>'+
                                                            '<br/>'+
                                                            '<br/>'+
                                                            '<span><label>' + language[lang].password_recover_3 + '</label></span>'+
                                                        '</div>'+
                                                    '</td>' +
                                                '</tr>' +
                                            '</table>'

                        await functionSendMail(Hosts.contactFrom, [email_request], [], language[lang].contact_recovery, mail_content, [])

                        Swal.fire(language[lang].submitted_application, language[lang].email_recover_pass, 'success')

                    }
                    else {

                        Swal.fire( language[lang].incorrect_request, language[lang].email_recover_pass_2, 'success')

                    }

                })
                .catch(() => 404)
        }
    }
        
    return(
        <div>
            <Navbar />
            <section id="recovery" className="pb-5">

                <div className="container-fluid bg-light py-5">
                    <div className="row">
                        <div className='container'>
                            <div className='row'>
                                <div className='col-12'>
                                    <h3 className="titulo-primario">
                                        <span>
                                            {language[lang].contact_recovery}
                                        </span>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className='row'>
                        <div className='col-12 my-5'>
                            <form onSubmit={handleSubmit}>

                                <div className="row">
                                    <div className="col-8 col-sm-6 mx-auto">
                                        <label>{language[lang].email}*</label>
                                        <input type="email" name="email" value={email_request} className="form-control" placeholder={language[lang].email_placeholder} onChange={(e) => set_email_request(e.target.value)} required />
                                        

                                        <div className="text-right">
                                            <Button className="mt-5 mx-auto" color="primary">{language[lang].send}</Button>     
                                        </div>    
                                    </div>
                                    
                                </div>                          

                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );


};

export default RequestRecoveryForm;